import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupAssignmentComponent } from './group-assignment/group-assignment.component';
import { MarkantElementsModule } from '@markant/elements-angular';
import { DashboardFeatureDashboardGroupAssignmentRoutingModule } from './dashboard-feature-dashboard-group-assignment-routing.module';
import { TranslocoModule } from '@jsverse/transloco';
import { ModalBridgeComponent } from '@markant-platform/shared/ui-modal';
import { SharedDialogFeatureModule } from '@markant-platform/shared/dialog/feature';
import { GroupAssignmentDetailComponent } from './group-assignment-detail/group-assignment-detail.component';
import { SharedTableFeatureModule } from '@markant-platform/shared/table/feature';
import { GroupNameEditDialogComponent } from './group-name-edit-dialog/group-name-edit-dialog.component';
import { CreateNewGroupComponent } from './group-assignment/create-new-group/create-new-group.component';
import { ReactiveFormsModule } from '@angular/forms';
import { GroupDeleteDialogComponent } from './group-delete-dialog/group-delete-dialog.component';
import { GroupAssignmentMemberEditDialogComponent } from './group-assignment-member-edit-dialog/group-assignment-member-edit-dialog.component';
import { UiCartridgeRolesAssignmentCardComponent } from '@markant-platform/shared/authorizer/ui';
import { ScrollIndicatorDirective } from '@markant-platform/shared/util-scroll';
import { UiPageHeaderComponent } from '@markant-platform/shared/ui-components';
import { ServiceRolesAssignmentsDialogComponent } from '@markant-platform/shared/authorizer/feature';

@NgModule({
  imports: [
    CommonModule,
    DashboardFeatureDashboardGroupAssignmentRoutingModule,
    MarkantElementsModule,
    TranslocoModule,
    SharedDialogFeatureModule,
    ModalBridgeComponent,
    SharedTableFeatureModule,
    GroupNameEditDialogComponent,
    ReactiveFormsModule,
    GroupDeleteDialogComponent,
    CreateNewGroupComponent,
    GroupAssignmentComponent,
    UiCartridgeRolesAssignmentCardComponent,
    ScrollIndicatorDirective,
    UiPageHeaderComponent,
    ServiceRolesAssignmentsDialogComponent,
  ],
  declarations: [GroupAssignmentDetailComponent, GroupAssignmentMemberEditDialogComponent],
})
export class DashboardFeatureDashboardGroupAssignmentModule {}
